import { render, staticRenderFns } from "./bx.vue?vue&type=template&id=105ea522&scoped=true&"
import script from "./bx.vue?vue&type=script&lang=js&"
export * from "./bx.vue?vue&type=script&lang=js&"
import style0 from "./bx.vue?vue&type=style&index=0&id=105ea522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105ea522",
  null
  
)

export default component.exports